import React, {useEffect} from "react";
import "./salesAutomation.css";
import deals_snapshot from "assets/dealManagement/deals-snapshot.png";
import multiple_sales_pipelines from "assets/dealManagement/multiple-sales-pipelines.png";
import deals_zia_view from "assets/dealManagement/deals-zia-view.png";
import deal_stages from "assets/dealManagement/deal-stages.png";
import quotes_deals from "assets/dealManagement/quotes-deals.png";
import deal_competition from "assets/dealManagement/deal-competition.png";
import deal_pipeline from "assets/dealManagement/deal-pipeline.png";
import celebrate_deals from "assets/dealManagement/celebrate-deals.png";
import Meta from "utils/meta";
import SubPageHeader from "Component/SubPageHeader/subPageHeader";
import ImageWithTextBlock from "Component/ImageWithTextBlock/imageWithTextBlock";

const DealManagement = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (<>
            <Meta title="Deal Management | The Realtor Desk" description=""/>
            <div className="sub-page--outer">
                <SubPageHeader
                    title="Close More Deals with the Right Deal Management Software"
                    subTitle="Great sales management is all about prioritizing, tracking, and monitoring deals in your pipeline. Realtor CRM's deal management software provides all the tools you need to manage deals across different territories and sales structures efficiently."
                />
                <div className="container">
                    <ImageWithTextBlock
                        shortTitle=""
                        title="Know where every deal stands, at a glance"
                        description="A customer or prospect can reach out to you in a number of ways. Respond to @mentions on Twitter, engage website visitors through live chat, call prospects, send emails, and manage all customer communication from CRM."
                        image={deals_snapshot}
                        imagePosition="right"
                    />
                    <ImageWithTextBlock
                        shortTitle=""
                        title="Create distinct sales pipelines for different processes"
                        description="Realtor CRM works seamlessly with help desk software, like Zendesk, Salesforce Desk, and Zoho Desk. With two-way help desk CRM integration, all your customer tickets are synced with relevant sales data and made accessible to your customer-facing teams, allowing them to provide a consistent customer experience."
                        image={multiple_sales_pipelines}
                        imagePosition="left"
                    />
                    <ImageWithTextBlock
                        shortTitle=""
                        title="Zia helps you identify the right deals to concentrate on"
                        description="Analytics helps you constantly refine email communication with customers. Discover the best day of the week to send out emails and campaigns by analyzing open rates, and learn which templates get the most responses. Set up your preferred email in Realtor CRM, and use both together."
                        image={deals_zia_view}
                        imagePosition="right"
                    />
                    <ImageWithTextBlock
                        shortTitle=""
                        title="Deal stages at a glance"
                        description="Recieve and segment notifications for posts and pings from your leads, prospects, and customers—and engage in conversations across Twitter and Facebook from within CRM."
                        image={deal_stages}
                        imagePosition="left"
                    />
                    <ImageWithTextBlock
                        shortTitle=""
                        title="Start quoting from within CRM"
                        description="Whether you're contacting the customer to resolve a support query, or making a sales pitch for a new cross-selling opportunity, it's important that your call gets picked up. Based on your previous interactions with customers, Zia—Zoho's AI assistant—will suggest the best times to get a hold of them."
                        image={quotes_deals}
                        imagePosition="right"
                    />
                    <ImageWithTextBlock
                        shortTitle=""
                        title="Keep tabs on the competition"
                        description="During sales follow-ups, prospects want to hear what makes your solution different from the competition. Use Realtor CRM to take notes on competitors' strengths and weaknesses, helping you pitch the advantages of your solution better and improve the chances of closing the deal faster."
                        image={deal_competition}
                        imagePosition="left"
                    />
                    <ImageWithTextBlock
                        shortTitle=""
                        title="Track your deal pipeline"
                        description="View in-depth reports about deals closing this month, daily revenue, sales stages, and more. Use dashboards to identify bottlenecks in the sales process and find areas for potential growth opportunities."
                        image={deal_pipeline}
                        imagePosition="right"
                    />
                    <ImageWithTextBlock
                        shortTitle=""
                        title="Celebrate sales together"
                        description="Spread the excitement of closing big deals with colleagues and managers. Set up a workflow alert from CRM to share the good news instantly. Our sales team the hardest working crew in the industry. They put their noses to the grindstone and get things done."
                        image={celebrate_deals}
                        imagePosition="left"
                    />
                </div>
            </div>
        </>);
};

export default DealManagement;
